/**
 * @author HungNS
 */
const isNumber = (n) => {
    return !isNaN(parseFloat(n)) && isFinite(n);
}
const set = key => (state, val) => {
    state[key] = val
}
export {isNumber,set}